<template>
    <b-tab :title="langTabTitle">
        <b-form-group v-if="schedules.length === 0">
            <label>
                <span key="lang_playlist_schedule_not_scheduled">Not Scheduled</span>
            </label>
            <p>
                <span key="lang_playlist_schedule_desc">This playlist currently has no scheduled times. It will play at all times. To add a new scheduled time, click the button below.</span>
            </p>
        </b-form-group>

        <b-card v-for="(row, index) in form.schedule_items.$each.$iter" :key="index" class="mb-3" no-body>
     
            <div class="card-header bg-info-dark d-flex align-items-center">
                <div class="flex-fill">
                    <h2 class="card-title">
                        <span :key="'lang_schedule_entry_'+index" :span-params="{ num: parseInt(index)+1 }">Scheduled Time {{ parseInt(index)+1}}</span>
                    </h2>
                </div>
                 <div class="card-tools">
                <button type="button" class="btn btn-tool text-info" data-card-widget="collapse" title="Collapse">
                  <i class="fas fa-minus"></i>
                </button>
                 <button type="button" class="btn btn-tool text-danger" @click.prevent="remove(index)">
                        <i class="fas fa-trash"></i>
                </button>
        
              </div>
                <!-- <div class="flex-shrink-0">
                    <b-button size="sm" variant="outline-info" class="py-2 pr-0" @click.prevent="remove(index)">
                        <i class="remove"></i>
                        <span key="lang_btn_remove">Remove</span>
                    </b-button>
                </div> -->
            </div>
            <b-card-body>
                <b-form-group>
                    <b-row>
                        <b-form-group class="col-md-4" :label-for="'edit_form_start_time_'+index">
                            <template v-slot:label>
                                <span key="lang_form_start_time">Start Time</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_start_time_desc">To play once per day, set the start and end times to the same value.</span>
                            </template>
                            <playlist-time :id="'edit_form_start_time_'+index" v-model="row.start_time.$model"
                                           :state="row.start_time.$dirty ? !row.start_time.$error : null"></playlist-time>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group class="col-md-4" :label-for="'edit_form_end_time_'+index">
                            <template v-slot:label>
                                <span key="lang_form_end_time">End Time</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_end_time_desc">If the end time is before the start time, the playlist will play overnight.</span>
                            </template>
                            <playlist-time :id="'edit_form_end_time_'+index" v-model="row.end_time.$model"
                                           :state="row.end_time.$dirty ? !row.end_time.$error : null"></playlist-time>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-col md="4" class="form-group">
                            <label>
                                <span key="lang_station_tz">Station Time Zone</span>
                            </label>
                            <div>
                                <span key="lang_station_tz_desc" :span-params="{ tz: stationTimeZone }">This station's time zone is currently {{stationTimeZone}}.</span>
                            </div>
                        </b-col>

                        <b-form-group class="col-md-4" :label-for="'edit_form_start_date_'+index">
                            <template v-slot:label>
                                <span key="lang_form_start_date">Start Date</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_start_date_desc">To set this schedule to run only within a certain date range, specify a start and end date.</span>
                                <div v-if="hasAdvancedSettings" class="text-danger">
                                    <span key="lang_form_start_date_warning">Start/end date cannot be used on playlists with advanced settings!</span>
                                </div>
                            </template>
                            <b-form-input :label-for="'edit_form_start_date_'+index" type="date"
                                          :disabled="hasAdvancedSettings"
                                          v-model="row.start_date.$model"
                                          :state="row.start_date.$dirty ? !row.start_date.$error : null"></b-form-input>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group class="col-md-4" :label-for="'edit_form_end_date_'+index">
                            <template v-slot:label>
                                <span key="lang_form_end_date">End Date</span>
                            </template>
                            <b-form-input :label-for="'edit_form_end_date_'+index" type="date"
                                          v-model="row.end_date.$model"
                                          :disabled="hasAdvancedSettings"
                                          :state="row.end_date.$dirty ? !row.end_date.$error : null"></b-form-input>
                            <b-form-invalid-feedback>
                                <span key="lang_error_required">This field is required.</span>
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group class="col-md-4" :label-for="'edit_form_days_'+index">
                            <template v-slot:label>
                                <span key="lang_form_days">Scheduled Play Days of Week</span>
                            </template>
                            <template v-slot:description>
                                <span key="lang_form_days_desc">Leave blank to play on every day of the week.</span>
                            </template>

                            <b-checkbox-group stacked :id="'edit_form_days_'+index" v-model="row.days.$model"
                                              :options="dayOptions"></b-checkbox-group>
                        </b-form-group>
                    </b-row>
                </b-form-group>
            </b-card-body>
        </b-card>

        <b-button-group>
            <b-button size="sm" variant="outline-info" @click.prevent="add">
                <i class="add"></i>
                <span key="lang_btn_add">Add Schedule Item</span>
            </b-button>
        </b-button-group>
    </b-tab>
</template>

<script>
import PlaylistTime from '@/components/common/TimeCode';

export default {
    name: 'PlaylistEditSchedule',
    components: { PlaylistTime },
    props: {
        form: Object,
        stationTimeZone: String,
        schedules: Array
    },
    data () {
        return {
            dayOptions: [
                { value: 1, text: 'Monday' },
                { value: 2, text: 'Tuesday' },
                { value: 3, text: 'Wednesday' },
                { value: 4, text: 'Thursday' },
                { value: 5, text: 'Friday' },
                { value: 6, text: 'Saturday' },
                { value: 7, text: 'Sunday' }
            ]
        };
    },
    computed: {
        langTabTitle () {
            return 'Schedule';
        },
        hasAdvancedSettings () {
            // return this.form.$model.backend_options.length > 1;
            return false;
        }
    },
    methods: {
        add () {
            this.$emit('add-schedule', {
                playlist_id: this.form.$model.playlist_id,
                start_time: null,
                end_time: null,
                start_date: null,
                end_date: null,
                days: []
            });
        },
        remove (index) {
            this.$emit('remove-schedule', parseInt(index));
        }
    }
};
</script>
